import { useEffect, useState } from "react";

/**
 * Returns the elapsed time since `joinedAt` as an `HH:MM:SS` (or `MM:SS`)
 * string, updated every second. `joinedAt` is an epoch-ms timestamp captured
 * once when the call session is opened — stays stable across re-renders so
 * the formatter has no drift.
 */
export function useCallDuration(joinedAt: number): string {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const elapsed = Math.max(0, Math.floor((now - joinedAt) / 1000));
  const h = Math.floor(elapsed / 3600);
  const m = Math.floor((elapsed % 3600) / 60);
  const s = elapsed % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  // Always zero-pad every segment so the string length (and tabular glyph
  // width) only changes at the rare MM:SS → HH:MM:SS boundary — not every
  // second as digits like "1" vs "0" swap under a proportional font.
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}
